import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Checks.es.js";
const o = e.forwardRef((c, r) => /* @__PURE__ */ e.createElement(s, { ref: r, ...c, weights: t }));
o.displayName = "ChecksIcon";
const n = o;
export {
  n as Checks,
  o as ChecksIcon
};
